module.exports = [
  {
    slug: "php2shell-php-runtime-rce-cve-2026-109618-109619",
    title: "PHP2Shell: Inside the PHP Runtime Flaws That Turn Fatal Errors into Remote Code Execution",
    excerpt:
      "PHP released critical fixes for CVE-2026-109618 and CVE-2026-109619 — native memory-safety flaws in PHP's own request lifecycle, not a CMS plugin issue. Both score 9.2 on CVSS v4.0, unauthenticated RCE is confirmed on Apache mod_php, and AWS telemetry shows exploitation attempts predating the public patch by four days.",
    date: "2026-10-23",
    displayDate: "October 2026",
    category: "Vulnerability Research",
    readTime: "16 min read",
  },
  {
    slug: "cloudsyncd-macos-backdoor-fake-zoom-installer",
    title: "CloudSyncD: Technical Analysis of a Fake Zoom Installer and macOS Backdoor",
    excerpt:
      "A two-stage macOS backdoor delivered through a fake Zoom.dmg installer, hiding a locally-validated password inside a JSON config file using zero-width Unicode characters, then launching an embedded Mach-O implant via sudo. Based on Jamf Threat Labs' original research.",
    author: "Vivek Kumar",
    date: "2026-10-23",
    displayDate: "October 2026",
    category: "Vulnerability Research",
    readTime: "11 min read",
  },
  {
    slug: "q3-2026-ransomware-trends-report",
    title: "The Ransomware Economy Expands: Activity Got Bigger, Broader and More Fragmented",
    excerpt:
      "CyberMon DRI telemetry recorded 2,942 ransomware victims in Q3 2026, up 24% from Q2, as active groups grew from 89 to 106 and 34 new brands surfaced in a single quarter. Manufacturing overtook Professional Services as the most-hit sector, and a dedicated India dataset shows 75 victims — led by TheGentlemen, Krybit, and the newly emerged Vexy Ransomware.",
    date: "2026-10-16",
    displayDate: "October 2026",
    category: "Digital Risk Intelligence",
    readTime: "14 min read",
  },
  {
    slug: "cve-2026-96940-exchange-server-elevation-of-privilege",
    title:
      "CVE-2026-96940: Microsoft Reissues the September Exchange Server Update for a New Elevation-of-Privilege Flaw",
    excerpt:
      "Microsoft quietly reissued its September 2026 on-premises Exchange security update to add CVE-2026-96940, a CVSS 8.8 authorization flaw that lets an already-authenticated, low-privilege user cross a privilege boundary. Organizations that patched the original release aren't automatically covered — what changed, what's affected, and how to hunt for exposure.",
    author: "Vivek Kumar",
    date: "2026-10-03",
    displayDate: "October 2026",
    category: "Vulnerability Research",
    readTime: "12 min read",
  },
  {
    slug: "chains-they-cant-seize-ransomware-blockchain-infrastructure",
    title: "Chains They Can't Seize: How Ransomware Turned the Blockchain Into a Hideout",
    excerpt:
      "LockBit came back within days of a major law-enforcement takedown. DeadLock never needed a conventional server to begin with. A look at EtherHiding, decentralized dead drops, and the first state-sponsored use of blockchain-based malware infrastructure — and what it means for defenders.",
    date: "2026-09-21",
    displayDate: "September 2026",
    category: "Threat Intelligence",
    readTime: "10 min read",
  },
  {
    slug: "vexy-ransomware-raas-threat-intelligence",
    title:
      "Vexy Ransomware: Inside an Emerging RaaS Operation's Affiliate Pitch and India-Heavy Victim List",
    excerpt:
      "An underground forum advertisement for a new \"Vexy\" affiliate program claims Rust-based Windows, Linux, and ESXi lockers behind a $200 invitation fee — and its leak site is already listing ten claimed victims, seven of them Indian organizations. Here's what's advertised, what's observed, and what remains unproven.",
    date: "2026-09-12",
    displayDate: "September 2026",
    category: "Digital Risk Intelligence",
    readTime: "13 min read",
  },
  {
    slug: "licindia-meduzalocker-data-exposure-claim",
    title:
      "MeduzaLocker's \"Licindia\" Data Leak: Inside a Structured, Multi-Directory Exposure Claim",
    excerpt:
      "MeduzaLocker's data-leak site lists a victim named \"Licindia,\" linked to licindia.com, with a categorized repository spanning Financial, HR, Legal, Marketing, Reports and Clients data offered for $50,000. Here's what the leak site actually shows, what it doesn't prove, and what to do next.",
    date: "2026-09-05",
    displayDate: "September 2026",
    category: "Digital Risk Intelligence",
    readTime: "11 min read",
  },
  {
    slug: "agentic-soc-security-leaders-guide-2026",
    title: "The Agentic SOC: What Security Leaders Need to Get Right",
    excerpt:
      "Real AI SOC deployment still sits at just 1-5% of organizations, yet fewer than half of CISOs can honestly say they know what their own AI agents are doing. A practical governance, readiness, and vendor-evaluation guide for moving from pilot to production without creating a new problem in the process.",
    date: "2026-08-20",
    displayDate: "August 2026",
    category: "AI Security Operations",
    readTime: "14 min read",
  },
  {
    slug: "bank-of-baroda-data-breach-triplex-claim",
    title: "Bank of Baroda Data Breach: What the TripleX Listing and Public Confirmation Reveal",
    excerpt:
      "TripleX claims roughly 1TB of Bank of Baroda customer and operational data — and unlike most underground claims, the bank has publicly confirmed a security incident. Here's what's confirmed, what's still alleged, and what to do next.",
    date: "2026-07-27",
    displayDate: "July 2026",
    category: "Digital Risk Intelligence",
    readTime: "10 min read",
  },
  {
    slug: "rapidfort-569gb-data-sale-claim",
    title:
      "Alleged 569GB RapidFort Data Sale: Detailed Analysis of a Cloud and Software Supply-Chain Exposure Claim",
    excerpt:
      "A threat actor claims to be selling 569GB of RapidFort data — 140,061 files from 48 S3 buckets — tied to the CanisterWorm/TeamPCP supply-chain campaign, including cloud credentials, Kubernetes configs, and vulnerability-database internals.",
    date: "2026-07-23",
    displayDate: "July 2026",
    category: "Digital Risk Intelligence",
    readTime: "13 min read",
  },
  {
    slug: "pappyjoe-data-breach-claim-kazu-extortion",
    title:
      "PappyJoe Data Breach Claim: Why Healthcare Platforms Face High-Impact Data Extortion Risk",
    excerpt:
      "The extortion group Kazu claims to hold 413GB of PappyJoe healthcare-management data, including 6.8M+ patient records. Here's the forum evidence, the Kazu group's activity timeline, and what it means for healthcare platforms.",
    date: "2026-07-20",
    displayDate: "July 2026",
    category: "Digital Risk Intelligence",
    readTime: "11 min read",
  },
  {
    slug: "accenture-breach-claim-underground-forum",
    title:
      "Accenture Breach Claim on an Underground Forum: Why Source Code and Cloud Secrets Are a Supply-Chain Risk",
    excerpt:
      "A threat actor claims to be selling 35GB+ of Accenture source code, RSA keys, SSH keys, Azure PATs, and Azure Storage access keys. Here's what the forum evidence shows and what it means for third-party risk.",
    date: "2026-07-09",
    displayDate: "July 2026",
    category: "Digital Risk Intelligence",
    readTime: "9 min read",
  },
];
